<template>

  <div>
    <v-dialog v-model="isDisplayed"
              :persistent="true"
              max-width="700px">
      <v-card>
        <p class="dialog-title">{{ dialogTitle }}</p>
        <v-card-text>
          <v-container fluid="fluid" grid-list-xl="grid-list-xl">

            <!-- LOGO -->
            <v-flex>
              <UploadInput label="Logo" v-model="editedCompetition.logo" :options="{mimeType: 'image/png', fillColor: 'transparent'}">
                <v-container slot="display">
                  <v-layout align-center>
                    <img :src="editedCompetition.logo ? editedCompetition.logo.file : null" alt="Logo" style="width: 100px; height: 100px; object-fit: contain; border: 2px dashed #949494;">
                    <v-flex>
                      <v-btn color="primary" flat @click="editedCompetition.logo = null">Remove logo</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </UploadInput>
            </v-flex>

            <!-- NAME -->
            <v-flex>
              <v-text-field v-model="editedCompetition.name" label="Name" placeholder="Name"></v-text-field>
            </v-flex>

            <!-- SPORT -->
            <v-flex>
              <SportSelector :currentSportIDs="editedCompetition.sportID"
                             @sportSelected="sportSelected"/>
            </v-flex>

            <!-- FEDERATION -->
            <v-flex>
              <FederationSelector :sportID="editedCompetition.sportID"
                                  :currentFederationID="editedCompetition.federationID"
                                  @federationSelected="federationSelected"/>
            </v-flex>

            <!-- REGION -->
            <v-flex>
              <RegionSelector :federationID="editedCompetition.federationID"
                              :currentRegionID="editedCompetition.regionID"
                              @regionSelected="regionSelected"/>
            </v-flex>

            <!-- CATEGORY -->
            <v-flex>
              <CategorySelector :federationID="editedCompetition.federationID"
                                :currentCategoryID="editedCompetition.categoryID"
                                @categorySelected="categorySelected"/>
            </v-flex>

            <!-- TOURNAMENT OR COMPETITION -->
            <v-flex>
              <v-switch v-model="editedCompetition.isTournament" label="Is a tournament"></v-switch>
            </v-flex>

            <!-- START DATE (TOURNAMENT) -->
            <v-flex v-if="editedCompetition.isTournament">
              <DateSelector ref="startDateSelector"
                            :currentDate="editedCompetition.startDate"
                            :label="'Start Date'"
                            @dateSelected="startDateSelected"/>
            </v-flex>

            <!-- END DATE (TOURNAMENT) -->
            <v-flex v-if="editedCompetition.isTournament">
              <DateSelector ref="endDateSelector"
                            :currentDate="editedCompetition.endDate"
                            :label="'End Date'"
                            @dateSelected="endDateSelected"/>
            </v-flex>

          </v-container>

          <!-- BUTTONS -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   flat="flat"
                   @click.native="close">Cancel</v-btn>
            <v-btn color="primary"
                   @click.native="save">{{ dialogButton }}</v-btn>
          </v-card-actions>

          <!-- ERROR -->
          <v-flex>
            <v-spacer></v-spacer>
            <div class="error-message">{{ errorMessage }}</div>
          </v-flex>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import SportSelector from '../common/SportSelector'
import FederationSelector from '../common/FederationSelector'
import RegionSelector from '../common/RegionSelector'
import CategorySelector from '../common/CategorySelector'
import DateSelector from '../common/DateSelector'
import UploadInput from '../forms/UploadInput'

export default {
  name: 'Dialog',
  components: {
    RegionSelector,
    FederationSelector,
    SportSelector,
    CategorySelector,
    DateSelector,
    UploadInput
  },
  props: [
    'dialog',
    'dialogState',
    'currentEditedCompetition',
    'errorMessage'
  ],
  data () {
    return {
      isDisplayed: false,

      editedCompetition: {
        logo: null,
        name: '',
        sportID: '',
        federationID: '',
        regionID: '',
        categoryID: '',
        isTournament: false,
        startDate: null,
        endDate: null
      },

      logoUploaderToggled: false
    }
  },
  mounted () {
    if (this.currentEditedCompetition) {
      this.setCurrentEditedCompetition()
    }
    if (this.dialog) {
      this.isDisplayed = true
    }
  },
  methods: {
    setCurrentEditedCompetition () {
      this.editedCompetition = {
        logo: this.currentEditedCompetition.logoURL ? { file: this.currentEditedCompetition.logoURL } : null,
        name: this.currentEditedCompetition.name,
        sportID: this.currentEditedCompetition.sportID,
        federationID: this.currentEditedCompetition.federationID,
        regionID: this.currentEditedCompetition.regionID,
        categoryID: this.currentEditedCompetition.categoryID,
        isTournament: this.currentEditedCompetition.isTournament,
        startDate: this.currentEditedCompetition.startDate || null,
        endDate: this.currentEditedCompetition.endDate || null
      }
    },
    save () {
      if (this.dialogState === 'create') {
        this.$emit('createCompetition', this.editedCompetition, this.editedCompetition.logo)
      } else {
        this.$emit('editCompetition', this.editedCompetition, this.editedCompetition.logo)
      }
    },

    sportSelected (sportid) {
      this.editedCompetition.sportID = sportid
    },
    federationSelected (federationid) {
      this.editedCompetition.federationID = federationid
    },
    regionSelected (regionid) {
      this.editedCompetition.regionID = regionid
    },
    categorySelected (categoryid) {
      this.editedCompetition.categoryID = categoryid
    },
    startDateSelected (date) {
      this.editedCompetition.startDate = date
    },
    endDateSelected (date) {
      this.editedCompetition.endDate = date
    },

    close () {
      this.clearData()
      this.isDisplayed = false
    },
    clearData () {
      this.editedCompetition = {
        name: '',
        sportID: '',
        federationID: '',
        regionID: '',
        categoryID: '',
        isTournament: false,
        startDate: null,
        endDate: null
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.dialogButton + ' competition'
    },

    dialogButton () {
      return this.dialogState.charAt(0).toUpperCase() + this.dialogState.slice(1)
    }
  },
  watch: {
    'dialog' () {
      if (this.isDisplayed !== this.dialog) {
        this.isDisplayed = this.dialog
      }
    },
    'isDisplayed' () {
      if (!this.isDisplayed) {
        this.clearData()
        this.$emit('dialogClosed')
      }
    },
    'currentEditedCompetition' () {
      if (this.currentEditedCompetition) {
        this.setCurrentEditedCompetition()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.dialog-title {
  font-size: 16px;
  text-align: center;
  font-weight: 700;
  padding-top: 20px;
}

.error-message {
  color: red;
  text-align: end;
  font-weight: 700;
}

</style>



// WEBPACK FOOTER //
// src/components/competitions/Dialog.vue